import gql from 'graphql-tag';
import { graphql, compose } from 'react-apollo';

import StudentReport from './components/StudentReport';

const StudentReportQuery = gql`
query {
  getUserSalesReport {
    user {
      id
      first_name
      last_name
    }
    top_industries {
      id
      name
    }
    summaries {
      advisor {
        first_name
      }
      summary_text
      summary_date
    }
    learning_plan {
      module_name
      student_goal
      sessions {
        scheduled_to
        advisor {
          first_name
          last_name
          photo
          job_positions {
            name
            company {
              name
            }
          }
        }
        Industry {
          name
        }
      }
    }
    scores {
      id
      skill_name
      skill_description
      parent {
        id
        skill_name
        skill_description
      }
      children {
        id
        skill_name
        skill_description
        skill_scores {
          skill_score
        }
      }
    }
  }
}
`;

export default (store) => ({
  path: '/',
  component:  compose(
    graphql(StudentReportQuery, {
      name: 'StudentReportData'
    })
  )(StudentReport)
});



// WEBPACK FOOTER //
// ./src/routes/student-report/routes/StudentReport/index.js